import { css } from '@emotion/core';
import theme from '../../themes/default';

const commonStyle = css`
  font-family: ${theme.font.family.workSans};
`;

const medium = css`
  ${commonStyle}
  height: 40px;
`;

const small = css`
  ${commonStyle}
  height: 32px;
  line-height: ${theme.font.lineHeight.small};
`;

const xsmall = css`
  ${commonStyle}
  height: 22px;
  line-height: ${theme.font.lineHeight.small};
`;

export default {
  container: {
    bySize: {
      xsmall,
      small,
      medium,
    },
  },
};
